import type {StateCreator} from 'zustand'
import type {FilesRoutePayload} from '../../page-data/payloads/files'

export interface RepositorySlice {
  repository: {
    baseRepository: {
      id: number
      ownerLogin: string
      name: string
    }
  }
}
export interface RepositorySliceOpts {
  baseRepository: FilesRoutePayload['repository']
}

export const createRepositorySlice =
  ({
    baseRepository,
  }: RepositorySliceOpts): StateCreator<RepositorySlice, [['zustand/devtools', never]], [], RepositorySlice> =>
  () => {
    return {
      repository: {
        baseRepository: {
          id: baseRepository.id,
          ownerLogin: baseRepository.ownerLogin,
          name: baseRepository.name,
        },
      },
    }
  }
